var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotAssessed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3337 8.00033C9.49366 8.00033 8.00033 9.49366 8.00033 11.3337C8.00033 13.1737 9.49366 14.667 11.3337 14.667C13.1737 14.667 14.667 13.1737 14.667 11.3337C14.667 9.49366 13.1737 8.00033 11.3337 8.00033ZM12.4337 12.9003L11.0003 11.467V9.33366H11.667V11.1937L12.9003 12.427L12.4337 12.9003ZM12.0003 2.00033H9.88033C9.60033 1.22699 8.86699 0.666992 8.00033 0.666992C7.13366 0.666992 6.40033 1.22699 6.12033 2.00033H4.00033C3.26699 2.00033 2.66699 2.60033 2.66699 3.33366V13.3337C2.66699 14.067 3.26699 14.667 4.00033 14.667H8.07366C7.67924 14.2842 7.35838 13.8322 7.12699 13.3337H4.00033V3.33366H5.33366V5.33366H10.667V3.33366H12.0003V6.72033C12.4737 6.78699 12.9203 6.92699 13.3337 7.12033V3.33366C13.3337 2.60033 12.7337 2.00033 12.0003 2.00033ZM8.00033 3.33366C7.63366 3.33366 7.33366 3.03366 7.33366 2.66699C7.33366 2.30033 7.63366 2.00033 8.00033 2.00033C8.36699 2.00033 8.66699 2.30033 8.66699 2.66699C8.66699 3.03366 8.36699 3.33366 8.00033 3.33366Z",
    fill: "#8B8B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAssessed);
export default __webpack_public_path__ + "static/media/not-assessed.d2eb3e5558317c77e9bc0b1a012f3c94.svg";
export { ForwardRef as ReactComponent };